export const MENU_ITEMS = [
  {
    label: 'Windows',
    path: '',
    activePaths: [''],
    icon: 'windows'
  },
  {
    label: 'macOS',
    path: '',
    activePaths: [''],
    icon: 'macos'
  },
  {
    label: 'Android',
    path: '',
    activePaths: [''],
    icon: 'android'
  },
  {
    label: 'iOS',
    path: '',
    activePaths: [''],
    icon: 'ios'
  },
  // {
  //   label: 'Chrome',
  //   path: '',
  //   activePaths: [''],
  //   icon: 'chrome'
  // },
  // {
  //   label: 'Edge',
  //   path: '',
  //   activePaths: [''],
  //   icon: 'edge'
  // }
];

export const MENU_CONFIG = {
  showIcons: true,
  expandedByDefault: false
};
